export const PUSH_ALERT = 'PUSH_ALERT';
export const POP_ALERT = 'POP_ALERT';